module.exports = __webpack_public_path__ + "img/41.6ed83bfc.png";